<template>
  <div style="display: flex">
    <div class="card-form">
      <a-form-model
        ref="ruleForm"
        :layout="layout"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="指标项" prop="pointId">
          <a-tree-select
            v-model="form.pointId"
            :dropdownStyle="{ maxHeight: '210px' }"
            style="width: 100%"
            :tree-data="indexIetmTree"
            search-placeholder="请选择指标项"
            @change="changTreeData"
          />
        </a-form-model-item>
        <a-form-model-item label="规则名称" prop="name">
          <a-input v-model="form.name" allowClear />
        </a-form-model-item>
        <a-form-model-item label="题目" prop="questionIds">
          <a-tree-select
            v-model="form.questionIds"
            :dropdownStyle="{ maxHeight: '210px' }"
            style="width: 100%; max-height: 210px; overflow-y: auto"
            :tree-data="topicTree"
            tree-checkable
            :show-checked-strategy="SHOW_PARENT"
            search-placeholder="请选择题目"
            @change="changTreeData"
          />
        </a-form-model-item>
        <a-form-model-item label="计算方式" prop="type">
          <a-select v-model="form.type">
            <a-select-option :value="1">合计</a-select-option>
            <a-select-option :value="2">其中一项</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="规则" prop="maxScore">
          <a-input-group compact>
            <a-input-number
              style="width: 100px; text-align: center"
              placeholder="最小值"
              v-model="form.minScore"
              allowClear
            />
            <a-input
              style="width: 30px; border-left: 0; pointer-events: none; background: #fff"
              placeholder="~"
              disabled
            />
            <a-input-number
              style="width: 100px; text-align: center; border-left: 0"
              placeholder="最大值"
              v-model="form.maxScore"
            />
          </a-input-group>
        </a-form-model-item>
        <a-form-model-item label="结果分析">
          <a-button type="primary" @click="openRichTextModal('resultAnalysis')">
            结果分析 - 富文本编辑
          </a-button>
        </a-form-model-item>
        <a-form-model-item label="建议">
          <a-button type="primary" @click="openRichTextModal('suggestion')">
            建议 - 富文本编辑
          </a-button>
        </a-form-model-item>
        <div style="display: flex; justify-content: flex-end; margin-top: 20px">
          <a-popconfirm ok-text="是" cancel-text="否" @confirm="$router.go(-1)">
            <template slot="title">
              <p>新增问卷模式下，取消操作会导致未保存的表单内容丢失</p>
              <p>确认要取消吗？</p>
            </template>
            <a-button>取消</a-button>
          </a-popconfirm>
          <a-button type="primary" style="margin: 0px 12px" @click="saveClick">保存</a-button>
          <a-button @click="prevClick">上一步</a-button>
        </div>
      </a-form-model>
    </div>
    <a-divider type="vertical" style="height: 600px; margin: 0 20px" />
    <div style="flex: 1">
      <div style="margin: 10px 0">
        <a-button type="danger" ghost :disabled="!selectedRowKeys.length" @click="batchDeleteRow">
          批量删除
        </a-button>
      </div>
      <a-table
        rowKey="id"
        :columns="columns"
        :data-source="tableData"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        bordered
        :pagination="pagination"
      />
    </div>
    <EditRuleModal
      :treeData="{ indexIetmTree, topicTree }"
      :evaluationId="quesData.id || ''"
      ref="editModalRef"
      @updateTable="$emit('refreshQuesData')"
    />
    <!--    富文本编辑器-->
    <InventoryRichModal ref="InventoryRichModalRef" @handleOk="richTextHandleOk" />
  </div>
</template>

<script>
import { TreeSelect } from 'ant-design-vue'
import { deleteAction, postAction } from '@/api/manage'
import EditRuleModal from './components/EditRuleModal'
import InventoryRichModal from './components/InventoryRichModal.vue'

const SHOW_PARENT = TreeSelect.SHOW_PARENT

export default {
  name: 'CreateQuesRule',
  components: {
    EditRuleModal,
    InventoryRichModal,
  },
  props: {
    quesData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: true,
      layout: 'horizontal',
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
      form: {
        type: 1,
        // pointId: [],
        // questionIds: [],
        // minScore: '',
        // maxScore: '',
        // conclusion: '',
      },
      rules: {
        name: [{ required: true, message: '规则名称不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '计算类型不能为空', trigger: 'blur' }],
        pointId: [{ required: true, message: '指标项不能为空', trigger: 'change' }],
        questionIds: [{ required: true, message: '题目不能为空', trigger: 'change' }],
        maxScore: [{ required: true, message: '规则最小/最大值不能为空', trigger: 'blur' }],
      },
      SHOW_PARENT,
      indexIetmTree: [],
      topicTree: [],
      tableData: [],
      pagination: {
        // current: 1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        // showQuickJumper: true,
        showSizeChanger: true,
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '规则名称',
          dataIndex: 'name',
          align: 'center',
        },
        {
          title: '指标项',
          align: 'center',
          customRender: (_, record) => {
            const filterPoint = this.indexIetmTree.filter((item) =>
              record.pointId.includes(item.value)
            )
            return filterPoint.length ? filterPoint.map((item) => <a-tag>{item.title}</a-tag>) : ''
          },
        },
        {
          title: '规则',
          dataIndex: 'minScore',
          align: 'center',
          customRender: (_, record) => {
            return (
              <div>
                <a-tag>
                  {record.minScore}~{record.maxScore}
                </a-tag>
              </div>
            )
          },
        },
        // { title: '结论', dataIndex: '', align: 'center' },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          customRender: (_, record) => {
            return (
              <div style="cursor: pointer">
                <span style="color: #1890FF" onClick={() => this.editRule(record)}>
                  编辑
                </span>
                <a-divider type="vertical" />
                <a-popconfirm
                  title="确定要删除该规则吗？"
                  ok-text="是"
                  cancel-text="否"
                  onConfirm={() => this.deleteRule(record)}
                >
                  <span style="color: #f81d22">删除</span>
                </a-popconfirm>
              </div>
            )
          },
        },
      ],
      selectedRowKeys: [],
      parmasData: {},
    }
  },
  watch: {
    quesData: {
      handler(newVal) {
        if (Object.keys(newVal).length) {
          this.initInfo()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    initInfo() {
      this.tableData = this.quesData.evaluationRuleList.map((item, index) => ({
        ...item,
        index: index + 1,
      }))
      console.log('规则信息：', this.tableData)
      this.initTreeData()
    },
    initTreeData() {
      const allOption = {
        title: '全部',
        value: 'all',
        key: 'all',
      }
      this.indexIetmTree = []
      this.topicTree = []
      const evaluationPointList = this.quesData.evaluationPointList
      if (evaluationPointList.length) {
        const indexList = evaluationPointList.map((item) => ({
          title: item.name,
          value: item.id,
          key: item.id,
        }))
        // this.indexIetmTree.push({
        //   ...allOption,
        //   children: indexList,
        // })
        this.indexIetmTree.push(...indexList)
      }
      this.topicTree.push({
        ...allOption,
        children: [],
      })
      const evaluationQuestionList = this.quesData.evaluationQuestionList
      if (evaluationQuestionList.length) {
        const topicList = evaluationQuestionList.map((item) => ({
          title: item.name.length >= 40 ? item.name.substring(0, 40) + '...' : item.name,
          value: item.id,
          key: item.id,
        }))
        this.topicTree.push({
          ...allOption,
          children: topicList,
        })
      }
    },
    changTreeData(value) {
      console.log('选择信息：', value)
      let allKeys = []
      if (value.includes('all')) {
        allKeys = this.indexIetmTree[0].children.map((item) => item.key)
      }
    },
    saveClick() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return
        let questionIds = ''
        if (this.form.questionIds.includes('all')) {
          questionIds = this.topicTree[0].children.map((item) => item.value).join(',')
          // questionIds = 'all'
        } else {
          questionIds = this.form.questionIds.join(',')
        }
        const params = { ...this.form, questionIds, evaluationId: this.quesData.id }
        postAction('/schoolEvaluationRule/add', params).then((res) => {
          if (res.success) {
            this.$message.success('保存成功')
            this.$emit('refreshQuesData', this.quesData.id)
          }
        })
      })
    },
    deleteRule(record) {
      deleteAction('/schoolEvaluationRule/delete', { id: record.id }).then((res) => {
        if (res.success) {
          this.$message.success('删除成功')
          this.$emit('refreshQuesData')
        }
      })
    },
    batchDeleteRow() {
      // console.log('批量选中--', this.selectedRowKeys)
      deleteAction('/schoolEvaluationRule/deleteBatch', {
        ids: this.selectedRowKeys.join(','),
      }).then((res) => {
        if (res.success) {
          this.$message.success('批量删除成功')
          this.$emit('refreshQuesData')
        }
      })
    },
    editRule(record) {
      this.$refs.editModalRef.showModal(record)
    },
    prevClick() {
      this.$emit('prevClick')
    },
    deleteRow(index) {
      this.tableData.splice(index, 1)
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    openRichTextModal(field) {
      const richMapObj = {
        resultAnalysis: '结果分析',
        suggestion: '建议',
      }
      const data = {
        title: richMapObj[field],
        content: this.form[field],
        field,
      }
      this.$refs.InventoryRichModalRef.show(data)
    },
    richTextHandleOk(record) {
      this.$set(this.form, record.field, record.content)
    },
  },
}
</script>
<style scoped lang="less">
.input-btn {
  display: inline-block;
  padding: 2px 5px;
  color: #1890ff;
  cursor: pointer;
}
.card-form {
  width: 700px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}
/deep/ .ant-input-affix-wrapper {
  textarea {
    white-space: pre-wrap !important;
  }
}
.rich-text-show {
  height: 50px;
  max-height: 100px;
  margin-bottom: 10px;
  overflow-y: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
}
</style>
